export const BONDS_REQUEST = 'BONDS_REQUEST'
export const BONDS_RECEIVED = 'BONDS_RECEIVED'
export const BONDS_ERROR = 'BONDS_ERROR'
